export default __webpack_public_path__ + "static/media/lists.02e10754.svg";